/**
* @name APP u-Planning
* @autor over.martinez@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: perfiltrayectoriatable
* # alias: Perfil
*/

export default class perfiltrayectoriatable {

    constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant, perfilSrv, $cookies, $mdDialog, i18nService) {
        this.$scope = $scope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.ngNotify = ngNotify;
        this.$stateParams = $stateParams;
        this.perfilSrv = perfilSrv;
        this.$mdDialog = $mdDialog;
        this.userinfo = null;
        this.$cookies = $cookies;
        this.$scope.img_grediant_circle_1 = require("../images/img_grediant_circle_1.jpg")
        this.$scope.gridOptionsComplex = {
            enableFiltering: true,
            showFooter: true,
            enableGridMenu: true,
            //rowHeight: 36,
            columnDefs: [
                { displayName: 'Cargo',field:'Cargo', width: '20%' },
                { displayName: 'Rol',field:'dsRol', width: '20%' },
                { displayName: 'Año Inicio',field:'dtInit', width: '10%' },
                { displayName: 'Año Finalización',field:'dtEnd', width: '10%' },
                { displayName: 'Unidad',field:'dsUnidad', width: '20%' },
                { displayName: 'Dedicación',field:'Dedicacion', width: '20%' }
            ]
        };

        this.$scope.gridOptionsDelegation = {
            enableFiltering: true,
            showFooter: true,
            enableGridMenu: true,
            //rowHeight: 36,
            columnDefs: [
                { displayName: 'Delegación', field: 'delegation', width: '40%' },
                { displayName: 'Unidad Académica',field:'dsUnidad', width: '40%' },
                { displayName: 'Fecha inicio',field:'dtInit', width: '20%' },
            ]
        };

        this.$scope.UserInfoConstant = UserInfoConstant;
        this.$scope.$watch('UserInfoConstant[0].details[0]', (details, before) => {
            if (details !== undefined) {
                this.userinfo = details.user;
                this.userinfo.role_id = this.$cookies.get('hasRoleId');
                this.main();
            }
        });
        i18nService.setCurrentLang('es')
    }

    main() {
        /**
        * Si no se ha especificado un teacherId, verifica el tipo de Role y si es Docente le buscar su respectivo teacherId
        **/
        if (this.$stateParams.teacherId != '') {
            this.userinfo.teacherId = this.$stateParams.teacherId;
            this.getTableData(this.userinfo.teacherId);
        } else {
            this.perfilSrv.role.getType({param1: this.userinfo.role_id}).$promise.then((response) => {
                if (!response.status) {
                    this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
                } else {
                    this.role = response.data[0];
                    if (this.role.types == 'TEACHER') {
                        this.getInfo();
                    } else {
                        this.$state.go('profile.perfil_dash');
                        this.ngNotify.set('No se ha especificado ningún docente', 'info');
                    }
                }
            }, (err) => {
                this.ngNotify.set('Imposible conectar con el servicio', 'error');
            });
        }
    }

    goBack(){
        this.$state.go('profile.perfil_dash', {teacherId:this.$stateParams.teacherId})
    }

    getInfo() {
        this.perfilSrv.role.getInfo({param1: this.userinfo.id}).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.userinfo.teacherId = response.data[0].idTeacher;
                this.getTableData(this.userinfo.teacherId);
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    getTableData() {
        this.perfilSrv.perfildocente.trayectoriaUR({teacherId: this.userinfo.teacherId}).$promise.then((response) => {   
            if(!response.status){
                return this.ngNotify.set('Imposible conectar con el servicio', 'error');
            }

            this.$scope.gridOptionsComplex.data = response.data.trajectory;
            this.$scope.gridOptionsDelegation.data = response.data.delegation
        }, (data) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    trajectoryDetails(item) {
        let params = {
            teacherId: this.userinfo.teacherId,
            year: item.Year,
            idHist: item.idHistActiv
        }
        this.perfilSrv.perfildocente.trayectoriaURDetail(params).$promise.then((response) => {
            if (!response.status) {
                this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
            } else {
                this.$scope.graphDetails = response.data[0];
                this.showModal();
            }
        }, (err) => {
            this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
    }

    showModal () {
        console.log('sup');
        var confirm = this.$mdDialog.confirm({
            controller   : 'modalDetailsURtCtrl',
            controllerAs : 'PerfilDialog',
            template     : require('./modalDetails/modalDetailsURt.html'),
            locals       : null,
            preserveScope: true,
            scope        : this.$scope, 
            animation    : true,
            clickOutsideToClose : true
        })

        this.$mdDialog.show(confirm);




    } 

}

perfiltrayectoriatable.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant', 'perfilSrv', '$cookies', '$mdDialog', 'i18nService'];



// WEBPACK FOOTER //
// ./src/app/u-faculty/profile/perfil/UR_trajectory/trayectoriaurcontroller.js